// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3okEz","buttons":"RemoveExpirationActionButtons_buttons__1llZl"};